import { supabase } from './supabase'

/** Load bundle children for a package catalogue item. */
export async function fetchPackageChildItems(packageItemId: string): Promise<
  Array<{ id: string; name: string; work_description?: string | null; default_checklist?: unknown }>
> {
  const { data, error } = await supabase
    .from('service_item_bundle_children')
    .select(
      'child_item_id, sort_order, child:service_items!service_item_bundle_children_child_item_id_fkey(id, name, work_description, default_checklist)'
    )
    .eq('package_item_id', packageItemId)
    .order('sort_order', { ascending: true })

  if (error || !data) return []
  return data
    .map((row: any) => row.child)
    .filter((c: any): c is { id: string; name: string } => !!c?.id)
}

/** Build $0 contract-service stubs for package children (ops/scheduling only). */
export function buildPackageChildServices(
  children: Array<{ id: string; name: string }>,
  options: {
    packageServiceId: string
    serviceType?: string
    recurrence?: {
      recurrence_type?: string | null
      recurrence_days?: number[]
    }
  }
): any[] {
  return children.map((child, index) => ({
    id: `pkg_child_${options.packageServiceId}_${child.id}_${index}`,
    service_item_id: child.id,
    service_type: options.serviceType || '',
    service_name: child.name,
    amount: 0,
    description: child.name,
    scheduled_date: null,
    scheduled_time: null,
    is_maintenance: false,
    schedule: {
      recurrence_type: options.recurrence?.recurrence_type ?? null,
      recurrence_days: options.recurrence?.recurrence_days || [],
      dsny_integration: false,
      garbage_schedule: [],
      recycling_schedule: [],
      organics_schedule: [],
      bulk_schedule: [],
      interior_cleaning_schedule: [],
    },
  }))
}
